import styled from 'styled-components'
import { colors } from 'src/Global/Styles/variables'

export const transforms = {
  top: 'translateY(-100%)',
  right: 'translateX(100%)',
  bottom: 'translateY(100%)',
  left: 'translateX(-100%)',
}

const placements = {
  top: {
    top: 0,
    right: 0,
    left: 0,
  },
  right: {
    top: 0,
    right: 0,
    bottom: 0,
  },
  bottom: {
    right: 0,
    bottom: 0,
    left: 0,
  },
  left: {
    top: 0,
    bottom: 0,
    left: 0,
  },
}

export interface DrawerWrapperProps {
  position: keyof typeof transforms
  open: boolean
  size: string | number
}

export interface DrawerOverlayProps {
  open: boolean
}

export interface DrawerContentProps {
  position: keyof typeof transforms
  open: boolean
  size: string | number
  styles?: string
  speed: number
  padding?: string
}

export const DrawerOverlay = styled.div<DrawerOverlayProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
  display: ${({ open }) => (open ? null : 'none')};
  background-color: ${colors.darkGrey};
  opacity: 0.8;
`

export const DrawerWrapper = styled.div<DrawerWrapperProps>`
  display: block;
  max-height: 100vh;
  width: ${({ position, size }) =>
    position !== 'top' && position !== 'bottom' && size ? size : '300px'};
`

export const DrawerContent = styled.div<DrawerContentProps>`
  padding: ${({ padding }) => padding};
  display: block;
  box-sizing: border-box;
  position: fixed;
  ${({ position }) => placements[position]}
  z-index: 16;
  width: 100%;
  transform: ${({ open, position }) => (!open ? transforms[position] : null)};
  transition-timing-function: ${({ open }) => (!open ? 'ease-in' : 'ease-out')};
  transition: ${({ speed }) => speed}s;
  overflow-x: hidden;
  overflow-y: scroll;
  color: #000;
  background-color: ${colors.white};

  ${({ styles }) => styles};

  @media (min-width: ${({ size }) => size || '300px'}) {
    width: ${({ position, size }) =>
      position !== 'top' && position !== 'bottom' && size ? size : '300px'};
  }
`
